"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Dropdown = require("./Dropdown.styled");
var _flexComponents = require("../flex-components");
var _styles = require("../../shared/styles");
var _LabelOverComponent = _interopRequireDefault(require("../../molecules/LabelOverComponent"));
var _Input = require("../Input");
var _Icon = require("../Icon");
var _Dropdown2 = require("./Dropdown");
var _jsxRuntime = require("react/jsx-runtime");
var ColorMenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "DropdownMenuColor__ColorMenuWrapper",
  componentId: "sc-1odyyc4-0"
})(["padding:", " ", ";"], _styles.spacing.xs, _styles.spacing.s);
var DropdownMenuColor = function DropdownMenuColor() {
  try {
    (0, _react.useContext)(_Dropdown2.DropdownContext);
  } catch (e) {
    throw new Error('Please wrap me in the dropdown component');
  }
  var _ref = (0, _react.useContext)(_Dropdown2.DropdownContext),
    selectItem = _ref.selectItem,
    initialValue = _ref.initialValue,
    setSelectedItem = _ref.setSelectedItem,
    expanded = _ref.expanded;
  var _ref2 = (0, _react.useState)(-1),
    _ref3 = _slicedToArray(_ref2, 2),
    selectedIndex = _ref3[0],
    setSelectedIndex = _ref3[1];
  var _ref4 = (0, _react.useState)(),
    _ref5 = _slicedToArray(_ref4, 2),
    customColor = _ref5[0],
    setCustomColor = _ref5[1];
  var _ref6 = (0, _react.useState)(true),
    _ref7 = _slicedToArray(_ref6, 2),
    validColor = _ref7[0],
    setValidColor = _ref7[1];
  var defaultColors = Object.values(_styles.colors.entity);
  var isSelected = function isSelected(index) {
    return index === selectedIndex;
  };
  var selectColor = function selectColor(e, index) {
    var value = e.target.dataset.value;
    if (value) selectItem(e, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Color, {
      data: value,
      color: value
    }));
    setSelectedIndex(index);
  };
  var validateColorCode = function validateColorCode(color) {
    return new RegExp('^#(?:[0-9a-fA-F]{3}){1,2}$').test(color);
  };
  var updateCustomColor = function updateCustomColor(color) {
    if (validateColorCode(color)) {
      setSelectedIndex(-1);
      setCustomColor(color);
      setValidColor(true);
    } else {
      setCustomColor(null);
    }
  };
  var createColorElement = function createColorElement(color, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Color, {
      "data-value": color,
      onClick: function onClick(e) {
        return selectColor(e, index);
      },
      color: color,
      children: isSelected(index) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: 'checkCircle',
        size: 'm'
      })
    }, color);
  };
  var createInitialItemColor = (0, _react.useCallback)(function () {
    return initialValue ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Color, {
      data: initialValue,
      color: initialValue
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.DiagonalLine, {});
  }, [initialValue]);
  (0, _react.useEffect)(function () {
    return setSelectedItem(createInitialItemColor());
  }, [createInitialItemColor, setSelectedItem]);
  (0, _react.useEffect)(function () {
    if (!expanded && !validColor) {
      setCustomColor('');
      setValidColor(true);
    }
  }, [expanded, validColor]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Menu, {
    expanded: expanded,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorMenuWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexColumn, {
        gap: 'm',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexColumn, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_flexComponents.FlexRow, {
            justifyContent: 'space-between',
            children: defaultColors.map(function (color, index) {
              return index <= 5 && createColorElement(color, index);
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_flexComponents.FlexRow, {
            justifyContent: 'space-between',
            children: defaultColors.map(function (color, index) {
              return index > 5 && createColorElement(color, index);
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_flexComponents.FlexRow, {
          alignItems: 'end',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LabelOverComponent.default, {
            label: 'Custom HEX',
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
              alignItems: 'center',
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
                value: customColor,
                error: !validColor,
                onChange: function onChange(value) {
                  return updateCustomColor(value.target.value);
                },
                onBlur: function onBlur(value) {
                  return value.target.value && setValidColor(validateColorCode(value.target.value));
                },
                size: 's'
              }), customColor ? createColorElement(customColor, defaultColors.length) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.DiagonalLine, {})]
            })
          })
        })]
      })
    })
  });
};
var _default = exports.default = DropdownMenuColor;